module.exports = __webpack_public_path__ + "static/media/jon-kravetz.a3fce0a9.png";